import React from 'react'
import { isExternalLink } from './utils'
import { Link } from 'react-router'
import { SourceEntity } from 'types/SourceEntity'
import { getPressReleaseLink } from '../../../../utils/get-press-release-link'

const shortenUrl = (url: string, keepChars: number) => {
    if (url.length <= keepChars * 2 + 3) return url
    return url.slice(0, keepChars) + '...' + url.slice(-keepChars)
}

const s3Url = (filename: string) => {
    // get first character of filename, lowercase
    const suffix = !filename.endsWith('.pdf') ? '.pdf' : ''
    const baseUrl = import.meta.env.VITE_S3_DOCS_BUCKET_URL || 'https://app-docs.financelab.se/'

    return `${baseUrl}${filename[0].toLowerCase()}/${filename}${suffix}`
}

export function SourceUrl({
    source: { sourceUrl, prId },
}: {
    source: Partial<Pick<SourceEntity, 'sourceUrl' | 'prId'>>
}) {
    if (prId) {
        const url = getPressReleaseLink('-', prId)

        return (
            <Link to={url} target='_blank'>
                {shortenUrl(url, 20)}
            </Link>
        )
    }

    if (sourceUrl) {
        const linkUrl = isExternalLink(sourceUrl) ? sourceUrl : s3Url(sourceUrl)

        return (
            <Link to={linkUrl} target='_blank'>
                {isExternalLink(sourceUrl) ? shortenUrl(sourceUrl, 20) : sourceUrl}
            </Link>
        )
    }
}
